import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { EmotionalSection } from './components/EmotionalSection';
import { ProblemSection } from './components/ProblemSection';
import { MethodSection } from './components/MethodSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ProductSection } from './components/ProductSection';
import { BonusesSection } from './components/BonusesSection';
import { ValueSection } from './components/ValueSection';
import { TransformationSection } from './components/TransformationSection';
import { ForYouSection } from './components/ForYouSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyBuyBar } from './components/StickyBuyBar';
import { Modal } from './components/Modal';
import { legalContent } from './data/content';
type ModalKey = 'privacy' | 'terms' | null;
export function App() {
  const [modal, setModal] = useState<ModalKey>(null);
  const active = modal ? legalContent[modal] : null;
  return <div className="w-full bg-ivory font-sans text-ink" data-id="element-0" data-mp="3rd19tixuhdo1">
      <main data-id="element-1" data-mp="67yvnd9206b">
        <Hero data-id="element-2" data-mp="4wyzymxdckh" />
        <EmotionalSection data-id="element-3" data-mp="5gg5d4r3wxg" />
        <ProblemSection data-id="element-4" data-mp="7ssnarqpf34" />
        <MethodSection data-id="element-5" data-mp="2zllff2q1qmn9" />
        <BenefitsSection data-id="element-6" data-mp="2zm4xqkjlzd1t" />
        <ProductSection data-id="element-7" data-mp="2zmwggus3xgao" />
        <BonusesSection data-id="element-8" data-mp="33mov9p83gioh" />
        <ValueSection data-id="element-9" data-mp="33m5e4aq9pybi" />
        <TransformationSection data-id="element-10" data-mp="33nggc642ey0i" />
        <ForYouSection data-id="element-11" data-mp="33orla998ybt7" />
        <TestimonialsSection data-id="element-12" data-mp="38m1elzzrb7mb" />
        <GuaranteeSection data-id="element-13" data-mp="38kqafz2efxuo" />
        <FaqSection data-id="element-14" data-mp="38kgmeh0x00rm" />
        <FinalCta data-id="element-15" data-mp="38o4d78ez692n" />
      </main>

      <Footer onOpenTerms={() => setModal('terms')} onOpenPrivacy={() => setModal('privacy')} data-id="element-16" data-mp="3dl4lzr37lpxg" />

      <StickyBuyBar data-id="element-17" data-mp="nwc2huqftzxb" />

      <Modal open={modal !== null} onClose={() => setModal(null)} title={active?.title ?? ''} paragraphs={active?.paragraphs ?? []} data-id="element-18" data-mp="nur948fv0n11" />
    </div>;
}